module.exports = __webpack_public_path__ + "static/media/header-375.07d6fec5.jpg";